/* ===== Internationalization ===== */
import { $ } from '../utils/helpers.js?v=82.86';

const I18N = {
  ro: {
    login_title: "Autentificare",
    email_label: "Email",
    password_label: "Parolă",
    login_btn: "Login",
    forgot: "Ai uitat parola?",
    reset_sent: "A fost trimis un link pentru a reseta parola.",
    create_account: "Creează cont",
    reg_title: "Înregistrare comerciant",
    name: "Nume",
    op_email: "Email operator (va fi contul)",
    op_pass: "Parolă (min 8)",
    company_name: "Nume firmă",
    op_consents: "Consimțăminte operator",
    will_save: "Aceste opțiuni vor fi salvate în setările contului.",
    create_btn: "Creează cont",
    back_btn: "◀ Înapoi",
    select_role: "Selectează Rolul",
    admin: "🛠️ Admin",
    client: "🎁 Client",
    logout: "Logout",
    logged_as: "Logat ca:"
  },
  en: {
    login_title: "Sign in",
    email_label: "Email",
    password_label: "Password",
    login_btn: "Sign in",
    forgot: "Forgot password?",
    reset_sent: "We sent you a reset link.",
    create_account: "Create account",
    reg_title: "Merchant registration",
    name: "Name",
    op_email: "Operator email (will be the account)",
    op_pass: "Password (min 8)",
    company_name: "Company name",
    op_consents: "Operator consents",
    will_save: "These options will be saved in account settings.",
    create_btn: "Create account",
    back_btn: "◀ Back",
    select_role: "Choose role",
    admin: "🛠️ Admin",
    client: "🎁 Client",
    logout: "Logout",
    logged_as: "Signed in as:"
  }
};

let locale = localStorage.getItem('sj_locale') || 'ro';

export function getLocale() {
  return locale;
}

export function setLocale(newLocale) {
  locale = newLocale;
  localStorage.setItem('sj_locale', locale);
  applyLocale();
}

export function getTranslation(key) {
  return I18N[locale]?.[key] || key;
}

export function applyLocale() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const k = el.getAttribute('data-i18n');
    const txt = I18N[locale]?.[k];
    if (typeof txt === 'string') el.textContent = txt;
  });
  const lt = $('langToggle');
  if (lt) lt.textContent = locale === 'ro' ? 'EN' : 'RO';
}

// Initialize language toggle
const lt = $('langToggle');
if (lt) {
  lt.addEventListener('click', () => {
    setLocale(locale === 'ro' ? 'en' : 'ro');
  });
}
